import { FI } from './fi'

export const sv: FI = {
  attachmentSelector: {
    title: 'Bifoga bilaga',
    generalInfo:
      'Genom att klicka detta område eller genoma att dra och släppa filen här',
    restrictionsInfo:
      '(Filens maximistorlek: 10 MB. Obs! Bankskydd kan förhindra infogning av bilagor. Inaktivera bankskyddet innan du fogar in bilagorna. Tillåtna filformat: PDF, JPEG/JPG, PNG, DOC/DOCX, PPT/PPTX och XLS/XLSX)',
    loading: 'Laddar...',
    error: {
      FileTooBig: 'Filen är för stor',
      InvalidExtension: 'Filtillägget {{ext}} är inte tillåtet',
      InvalidMimeType: 'Filformatet motsvarar inte filtillägget',
      MissingExtension: 'Filtillägget saknas',
      Unknown: 'Uppladdningen misslyckades',
      nonEmptyArray: 'Bilaga fattas!',
      PublishFailure: 'Det lyckas inte att foga bilagan till ansökan!'
    }
  },
  breadcrumb: {
    home: 'Hem',
    YOUTH_PROJECT_GRANT: 'Projektunderstöd',
    YOUTH_GENERAL_GRANT: 'Allmänt understöd'
  },
  common: {
    ok: 'Ok',
    cancel: 'Avbryt',
    edit: 'Redigera',
    modal: {
      defaultError: {
        title: 'Hoppsan! Något gick fel',
        text: 'Kontrollera anslutningen och försök igen efter ett tag. Om problemet kvarstår, vänligen kontakta nuoriso@espoo.fi.'
      },
      deleteApp: {
        title: 'Är du säker på att du vill ta bort ansökan?',
        text: 'Ansökan och dess uppgifter tas bort från systemet',
        confirmButtonLabel: 'Ta bort ansökan'
      },
      sessionExpired: {
        title: 'Din session har gått ut	',
        text: 'Klicka på OK för att logga in igen'
      },
      validationErrors: {
        title: 'Granska fälten'
      }
    },
    statuses: {
      DRAFT: 'Utkast',
      SIGNING: 'Väntar på underskrift',
      SENT: 'Inlämnad',
      REVIEW: 'Under behandling',
      PAYMENT_WAIT: 'Beviljad',
      PRE_REPORT: 'Beviljad',
      REJECTED: 'Betalas inte',
      POST_REPORT: 'Beviljad och betald',
      PAID: 'Beviljad och betald',
      RECOVERY: 'Återkrav',
      RECOVERED: 'Återkrävts'
    }
  },
  footer: {
    cityOfEspoo: 'Esbo stad',
    privacyPolicy: 'Dataskyddsbeskrivning',
    a11yStatement: 'Tillgänglighetsredogörelse',
    feedback: 'Ge respons'
  },
  header: {
    nav: {
      logout: 'Logga ut'
    },
    title: {
      label: 'Ungdomsunderstöd'
    }
  },
  org: {
    additionalInfo: {
      title: 'Sammanslutningsuppgifter som kompletterar ansökan',
      activity: {
        label: 'Verksamhet',
        values: {
          EARLY_YOUTH_ACTIVITIES: 'Verksamhet for yngre ungdomar',
          HOBBY_CLUBS: 'Hobbyklubbar',
          POLITICAL: 'Politisk ungdoms- och elevverksamhet',
          SCOUT: 'Scout',
          SPIRITUAL: 'Andlig verksamhet',
          OTHER: 'Annan ungdomsverksamhet'
        }
      },
      targetGroup: {
        label: 'Målgrupp',
        values: {
          ALL: 'Alla',
          BOYS: 'Pojkar',
          GIRLS: 'Flickor'
        }
      },
      members: {
        info: {
          label:
            'Sammanslutningens medlemsantal (antalet medlemmar i Esbo i början på året)'
        },
        from21to28: {
          label: '21–28-åriga'
        },
        from29: {
          label: '29-åriga och över'
        },
        from7to20: {
          label: '7–20-åriga'
        },
        total: {
          label: 'Medlemmar totalt'
        }
      }
    },
    address: {
      postalAddress: {
        label: 'Postadress'
      },
      postalCode: {
        label: 'Postnummer'
      },
      postOffice: {
        label: 'Postkontor'
      }
    },
    areas: {
      label: 'Verksamhetsområde',
      values: {
        SUUR_ESPOONLAHTI: 'Stor-Esboviken',
        SUUR_LEPPAVAARA: 'Stor-Alberga',
        SUUR_MATINKYLA: 'Stor-Mattby',
        SUUR_TAPIOLA: 'Stor-Hagalund',
        SUUR_KAUKLAHTI: 'Stor-Köklax',
        VANHA_ESPOO: 'Gamla Esbo',
        POHJOIS_ESPOO: 'Norra Esbo',
        OUTSIDE_OF_ESPOO: 'Utanför Esbo'
      }
    },
    bankAccount: {
      label: 'Kontonummer (IBAN)'
    },
    basicInfo: {
      label: 'Sammanslutningens uppgifter'
    },
    businessId: {
      label: 'FO-nummer'
    },
    domicile: {
      label: 'Hemort'
    },
    email: {
      label: 'E-post'
    },
    name: {
      label: 'Sammanslutningens namn'
    },
    registrationDate: {
      label: 'Registreringsdatum'
    },
    representativeRole: {
      CHAIRMAN: 'Huvudrepresentant',
      SIGNER: 'Representant'
    },
    representatives: {
      label: 'Sammanslutningens representanter'
    },
    requiredSignersAmount: {
      label: 'Minsta antal namntecknare'
    },
    type: {
      label: 'Sammanslutningens typ',
      ASSOCIATION: 'Förening',
      COMPANY: 'Företaget',
      FOUNDATION: 'Fonden'
    },
    wwwAddress: {
      label: 'Webbadress'
    }
  },
  validations: {
    dateWithinRange: 'Det ska vara mellan {{start}} - {{end}}',
    greaterThanOrEqual: 'Värdet måste vara {{min}} eller större',
    notNil: 'Värdet saknas',
    required: 'Obligatoriskt fält',
    withinRange: 'Det ska vara mellan {{min}}{{unit}} - {{max}}{{unit}}',
    attachmentsRequired: 'Minst {{min}} bilaga krävs'
  },
  views: {
    generalGrant: {
      form: {
        title: 'Allmänt understöd',
        appDetails: {
          title: 'Uppgifterna för understödet',
          detailsOfUse:
            'Användningsändamål för understödet som söks i stora drag',
          appliedSumInCents: 'Ansökt summa'
        },
        participants: {
          title: 'Antalet gånger Esbobor deltog i fjol',
          desc_1: 'Berätta hur många Esbobor som har deltagit i era evenemang',
          desc_2:
            'Exempel 1: Klubben var tre gånger i veckan och varje gång hade 20 deltagare. På ett år ordnades klubbar under 40 veckor. Antalet deltagargånger var totalt 2400.',
          desc_3:
            'Exempel 2: Lägret pågick i tre dagar. Lägret hade varje dag 20 deltagare. Antalet deltagargånger på lägret var totalt 60',
          from7to20: '7–20-åriga',
          from21to28: '21-28-åriga',
          total: 'Deltagargånger sammanlagt:'
        },
        goals: {
          title: 'Mål för sammanslutningens verksamhet för innevarande år',
          goals_1: 'Mål 1',
          goals_2: 'Mål 2',
          goals_3: 'Mål 3'
        },
        youngEspoo: {
          link: 'https://www.esbo.fi/sv-FI/Unga',
          title_1: 'Hur förverkligas berättelsen ',
          title_link: 'Ung Esbo',
          title_2: ' i sammanslutningens verksamhet?'
        },
        financialPlan: {
          label:
            'Plan för sammanslutningens medelanskaffning för innevarande år ',
          placeholder:
            'Med sammanslutningens medelanskaffning avses understöd som söks från olika ställen, biljettintäkter, försäljningsintäkter, medlemsavgifter osv.'
        },
        previousYear: {
          title: 'Föregående års ekonomi',
          totalProfitInCents: 'Räkenskapsperiodens resultat, euro',
          bankAccountSumInCents:
            'Bankkontosaldo {{lastDayOfPreviousYear}}, euro',
          selfAcquiredFundsInCents: 'Egen medelanskaffning',
          receivedGrants: {
            label: 'Understöd från Esbo stad och andra aktörer',
            placeholder: 'Aktörens namn och eurobelopp'
          }
        },
        attachments: {
          title: 'Bilagor',
          mandatoryAttachments: {
            title: 'Bifoga här följande obligatoriska bilagor *:',
            planForYear: 'Verksamhetsplan för {{year}}',
            budgetForYear: 'Budget för {{year}}',
            minutesOfAnnualMeeting:
              'Utdrag ur protokollet från årsmötet {{year}}',
            annualReport:
              'Den fastställda verksamhetsberättelsen för år {{year}}',
            financialStatemment: 'Det fastställda bokslutet för år {{year}}',
            auditForAYear: 'Verksamhetsgranskning år {{year}}'
          }
        },
        signing: {
          title: 'Underskrift',
          info: 'På underteckningssidan kan du kontrollera uppgifterna före underteckningen'
        }
      },
      preview: {
        appDetails: 'Uppgifterna för understödet',
        detailsOfUse: 'Användningsändamål för understödet som söks',
        appliedSum: 'Belopp som söks (euro)',
        activity: {
          label: 'Verksamhet',
          values: {
            EARLY_YOUTH_ACTIVITIES: 'Verksamhet for yngre ungdomar',
            HOBBY_CLUBS: 'Hobbyklubbar',
            POLITICAL: 'Politisk ungdoms- och elevverksamhet',
            SCOUT: 'Scout',
            SPIRITUAL: 'Andlig verksamhet',
            OTHER: 'Annan ungdomsverksamhet'
          }
        },
        members: {
          label: 'Medlemmarna',
          from7to20: 'Medlemmarna 7-20',
          from21to28: 'Medlemmarna 21-28',
          total: 'Det totala medlemsantalet'
        },
        participants: {
          label: 'Deltagargånger',
          from7to20: 'Deltagargånger 7-20',
          from21to28: 'Deltagargånger 21-28',
          total: 'Deltagargånger sammanlagt'
        },
        goals: {
          goals_1: 'Mål 1',
          goals_2: 'Mål 2',
          goals_3: 'Mål 3'
        },
        youngEspoo: 'Förverkligande av berättelsen Ung Esbo',
        financialPlan: 'Medelanskaffning',
        previousYear: {
          title: 'Föregående års ekonomi',
          totalProfitInCents: 'Räkenskapsperiodens resultat',
          bankAccountSumInCents: 'Bankkontosaldo {{lastDayOfPreviousYear}}',
          selfAcquiredFundsInCents: 'Egen medelanskaffning',
          receivedGrants: 'Mottagna understöd'
        }
      }
    },
    form: {
      appDetails: {
        title: 'Uppgifterna för understödet',
        text: 'Fyll i det ansökna understödets uppgifter samt deltagare. Fält markerade med en asterisk * är obligatoriska.',
        event: {
          name: 'Understödets syfte',
          location: 'Plats',
          startDate: 'Aktiviteten börjar',
          endDate: 'Aktiviteten avslutar'
        },
        purpose: 'Noggrannare beskrivning av understödets syfte',
        appliedTotal: 'Summa €',
        numberOfParticipants:
          'Uppskattade / faktiska antalet deltagare som bor i Esbo',
        participants: {
          ages7to20: {
            label: '7–20-åriga'
          },
          ages21to28: {
            label: '21–28-åriga'
          },
          ages29andOver: {
            label: '29-åriga och över'
          },
          total: {
            label: 'Totalt'
          }
        },
        totalParticipants: 'Totala antalet deltagare'
      },
      attachments: {
        title: 'Bilagor',
        text: 'Lägg till de bilagor du vill t.ex. kopior av kvitton.'
      },
      delete: {
        title: 'Är du säker på att du vill ta bort ansökan?',
        text: 'Ansökan och dess uppgifter tas bort från systemet',
        action: 'Ta bort ansökan'
      },
      expensesAndIncomes: {
        title: 'Utgifter och inkomster',
        expenses: {
          description: 'Utgift (beskrivning)',
          amount: 'Summa €',
          totalSum: 'Totala utgifterna:',
          delete: 'Ta bort utgift',
          add: 'Lägg till rad',
          title: 'Utgifter'
        },
        incomes: {
          description: 'Inkomst (beskrivning)',
          amount: 'Summa €',
          totalSum: 'Totala inkomsterna:',
          delete: 'Ta bort inkomst',
          add: 'Lägg till rad',
          title: 'Inkomster'
        }
      },
      newApplication: 'Ny ansökan',
      orgInfo:
        'Granska att sammanslutningens och undertecknarnas kontaktuppgifter är korrekta. Öka sammanslutningensuppgifter som kompletterar ansökan. * Skrivfälten med asterisk är obligatoriska.',
      saveAndClose: 'Spara och stäng',
      signing: {
        title: 'Underskrift',
        text: 'På underteckningssidan kan du kontrollera uppgifterna före underteckningen.'
      },
      toSigning: 'Gå till underteckningen'
    },
    home: {
      orgs: {
        title: 'Registrerat sammanslutningar',
        createOrgAction: 'Lägg till en sammanslutning'
      },
      org: {
        apps: {
          actions: {
            open: 'Öppna ansökan',
            delete: 'Ta bort ansökan'
          },
          columns: {
            grantPeriod: 'Ansökningsperiod',
            eventName: 'Understödets syfte',
            status: 'Status',
            workgroupEventLabel: 'Arbetsgrupp',
            appliedSum: 'Ansökt',
            decisionSum: 'Beslut'
          },
          statusDesc: {
            payImmediately: 'Betalas omedelbart',
            postReportApproved: 'Utredningen godkänd',
            postReportPaymentWait:
              'Betalas omedelbart, lämna in utredningen senast {{dueDate}}',
            postReportPending: 'Väntar på utredningen senast {{dueDate}}',
            preReportApproved: 'Utredningen godkänd, betalas {{amount}} €',
            preReportRejected: 'Utredningen avvisad',
            preReportWait: 'Lämna in utredningen senast {{dueDate}}',
            recovery:
              'Utredningen avslås, returnera {{amount}} € senast {{dueDate}}',
            recovered: 'Returnerade {{amount}} €'
          }
        },
        applyForGrant: {
          title: 'Ansök om projektunderstöd',
          date: 'senast {{date}}',
          titleAndDate: 'Ansök om projektunderstöd senast {{date}}',
          YOUTH_PROJECT_GRANT: 'Ansök om projektunderstöd',
          YOUTH_GENERAL_GRANT: 'Ansök om allmänt understöd'
        },
        incompleteApps: 'Ofullständiga ansökningar: {{count}}',
        showDetails: 'Visa ansökandens information'
      }
    },
    landing: {
      browserSupport: {
        unsupportedBrowser: 'Webbläsaren du använder stöds inte.',
        info: 'Systemet stöder endast de nyaste versionerna av Chrome och Firefox.'
      },
      welcome: {
        title: 'Välkommen för att ansöka om ungdomsunderstöd!',
        subtitle: 'Logga in med Suomi.fi-identifikationen!',
        button: 'Suomi.fi-identifikation'
      }
    },
    preview: {
      attachments: {
        app: {
          title: 'Bilagor'
        },
        report: {
          title: 'Utredningens bilagor'
        }
      },
      close: 'Stäng',
      expensesAndIncomes: {
        title: 'Utgifter och inkomster',
        expenses: {
          total: 'Utgifterna totalt:',
          title: 'Utgifter'
        },
        incomes: {
          total: 'Inkomsterna totalt:',
          title: 'Inkomster'
        }
      },
      processSteps: {
        APPLICATION: {
          title: 'Ansökan'
        },
        DECISION: {
          title: 'Beslut',
          REVIEW: 'Under behandling',
          REJECTED: 'Beviljas inte',
          GRANTED_PAY_IMMEDIATELY: 'Beviljas {{amount}} €, betalas omedelbart',
          GRANTED_PAY_IMMEDIATELY_WAIT_REPORT:
            'Beviljas {{amount}} €, väntar på utredningen',
          GRANTED_PAY_AFTER_REPORT:
            'Beviljas {{amount}} €, betalas efter utredningen'
        },
        PRE_REPORT: {
          title: 'Utredningen',
          PENDING: 'Senast {{dueDate}}',
          APPROVED: 'Utredningen godkänd, betalas {{amount}} €',
          REJECTED: 'Utredningen avvisad'
        },
        PAYMENT: {
          title: 'Betalning',
          PAID: 'Betald {{amount}} €',
          REJECTED: 'Betalas inte',
          ACTIVE: 'Under behandling'
        },
        POST_REPORT: {
          title: 'Utredningen',
          ACTIVE: 'Senast {{dueDate}}',
          APPROVED: 'Utredningen godkänd',
          REJECTED: 'Utredningen avslås'
        },
        RECOVERY: {
          title: 'Återkrav',
          PENDING:
            'Utredningen avslås, återkrav, returnera {{amount}} € senast {{dueDate}}',
          COMPLETED: 'Returnerad {{amount}} €'
        }
      },
      signing: {
        signedAt: 'Undertecknat: {{date}}'
      }
    },
    signing: {
      await: {
        title:
          'Underteckningen har lagts till! Ansökan kräver ännu en annan underteckning.',
        text: 'En annan representant måste logga in på tjänsten och underteckna ansökan.',
        controls: {
          confirm: 'ok'
        }
      },
      close: 'Stäng',
      confirm: {
        title: 'Du är på väg att underteckna ansökan',
        text: {
          sendAfterSign:
            'Efter underteckningen lämnas ansökan in. En inlämnad ansökan kan inte längre redigeras.',
          awaitAfterSign:
            'Efter underteckningen blir ansökan att vänta på en annan underteckning.'
        },
        controls: {
          cancel: 'Avbryt',
          confirm: 'Underteckna'
        }
      },
      edit: 'Redigera ansökan',
      link: {
        label: 'Understödsanvisning',
        url: 'https://www.espoo.fi/fi/nuorisoavustukset#section-19216'
      },
      org: {
        check:
          'Jag har kontrollerat att sammanslutningens och ansökans uppgifter är korrekta. Jag är över 18 år gammal och jag har rätt att underteckna ansökan på uppdrag av sammanslutningen.',
        notConfirmed: {
          title:
            'Uppgifterna om sammanslutningen och i ansökan har inte bekräftats',
          text: 'Kontrollera uppgifterna om sammanslutningen och i ansökan och bekräfta dem genom att klicka på ”Jag har kontrollerat att sammanslutningens och ansökans uppgifter är korrekta”.'
        },
        signers: 'Sammanslutningens namntecknare:',
        signingInfo:
          'Genom att underteckna förbinder sig sökanden att ge en helhetsredogörelse över sammanslutningens ekonomi senast den dag som nämns i beslutet om understöd och att returnera det beviljade understödet om sökanden bryter mot anvisningarna om idrotts- och ungdomsnämndens understöd. (',
        signingInfo2:
          '). Sökanden förbinder sig också att hålla sin bokföring och förvaltning tillgängliga för eventuella revisioner utförda av Esbo stad'
      },
      orgInfo:
        'Granska att sammanslutningens och undertecknarnas kontaktuppgifter är korrekta.',
      sign: 'Underteckna',
      success: {
        title: 'Ansökan har undertecknats och lämnats in!',
        text: 'Obs! Denna version av tjänsten skickar inga e-postbekräftelser av mottagandet och behandlingen av ansökan.',
        controls: {
          confirm: 'ok'
        }
      }
    }
  }
}
